import { ArrowLeft, Lock } from "lucide-react";
import { LogoFull } from "../components/Logo";
import { Footer } from "../components/Footer";
import { waLink, WA_MESSAGES, WHATSAPP_DISPLAY } from "../lib/whatsapp";

const SECTIONS = [
  {
    title: "1. Compromisso com o sigilo",
    body: "A TSS — ADVOGADOS trata a confidencialidade como pilar central da atuação. Além do sigilo profissional previsto no Estatuto da Advocacia (Lei 8.906/94), tratamos todos os dados pessoais em conformidade com a Lei Geral de Proteção de Dados (Lei 13.709/2018 — LGPD).",
  },
  {
    title: "2. Dados que coletamos",
    body: "Este site não possui formulários de cadastro nem áreas logadas. Ao clicar em um botão de WhatsApp, você é direcionado ao aplicativo da Meta Platforms, e a conversa passa a ser regida também pela política de privacidade do WhatsApp. Recebemos apenas as informações que você voluntariamente compartilhar na conversa (nome, telefone e descrição do caso).",
  },
  {
    title: "3. Finalidade do tratamento",
    body: "Os dados compartilhados são utilizados exclusivamente para: (a) análise preliminar do seu caso; (b) agendamento de consultas; (c) prestação dos serviços advocatícios contratados; e (d) cumprimento de obrigações legais e regulatórias. Não utilizamos seus dados para marketing não solicitado.",
  },
  {
    title: "4. Compartilhamento",
    body: "Não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros para fins comerciais. Informações só podem ser reveladas mediante sua autorização expressa ou por determinação legal/judicial, sempre na menor extensão necessária.",
  },
  {
    title: "5. Cookies e ferramentas de análise",
    body: "O site pode utilizar ferramentas de análise de navegação (como cookies de métricas anônimas) para melhorar a experiência. Você pode desativar cookies nas configurações do seu navegador sem prejuízo ao acesso ao conteúdo.",
  },
  {
    title: "6. Seus direitos como titular",
    body: "Nos termos da LGPD, você pode solicitar a qualquer momento: confirmação da existência de tratamento, acesso, correção, anonimização, portabilidade, eliminação dos dados e revogação do consentimento. Basta nos contatar pelo canal informado abaixo.",
  },
  {
    title: "7. Segurança e retenção",
    body: "Adotamos medidas técnicas e administrativas para proteger seus dados contra acessos não autorizados. Os dados são mantidos apenas pelo período necessário às finalidades descritas ou exigido por lei, sendo eliminados de forma segura após esse prazo.",
  },
  {
    title: "8. Encarregado de dados (DPO) e contato",
    body: `Para exercer seus direitos ou esclarecer dúvidas sobre esta política, fale com nosso encarregado de proteção de dados pelo WhatsApp ${WHATSAPP_DISPLAY} ou presencialmente em nosso escritório em Naviraí/MS, mediante agendamento.`,
  },
  {
    title: "9. Alterações desta política",
    body: "Esta política pode ser atualizada periodicamente para refletir mudanças legais ou operacionais. A versão vigente estará sempre disponível nesta página, com indicação da data de revisão.",
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="bg-[#0B1320] min-h-screen text-slate-100 font-sans-body" data-testid="privacy-page">
      <header className="border-b border-amber-500/15 bg-[#0B1320]/90 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
          <a href="/" data-testid="privacy-logo-link" aria-label="Voltar ao início">
            <LogoFull compact />
          </a>
          <a
            href="/"
            data-testid="privacy-back-link"
            className="inline-flex items-center gap-2 text-sm text-amber-200 hover:text-amber-300 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar ao site
          </a>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <p className="font-mono-num text-xs uppercase tracking-[0.3em] text-amber-400/90 mb-5 flex items-center gap-3">
          <Lock className="w-4 h-4" />
          Documento legal
        </p>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-100">
          Política de Privacidade &amp; LGPD
        </h1>
        <p className="text-sm sm:text-base text-slate-400 leading-relaxed mt-5 max-w-2xl">
          Como a TSS — ADVOGADOS coleta, utiliza e protege seus dados pessoais. O sigilo não é um
          detalhe do nosso serviço: é a nossa identidade.
        </p>
        <p className="font-mono-num text-[11px] text-slate-500 mt-4">
          Última revisão: outubro de 2026
        </p>

        <div className="mt-12 space-y-8">
          {SECTIONS.map((s, i) => (
            <section
              key={s.title}
              data-testid={`privacy-section-${i}`}
              className="border border-amber-500/10 bg-[#111C2E] rounded-2xl p-7 sm:p-8"
            >
              <h2 className="font-display text-lg sm:text-xl font-medium text-amber-100/95">
                {s.title}
              </h2>
              <p className="text-sm text-slate-400 leading-relaxed mt-3.5">{s.body}</p>
            </section>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href={waLink(WA_MESSAGES.faq)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="privacy-cta-whatsapp"
            className="inline-flex items-center gap-2.5 border border-amber-400/40 text-amber-200 font-semibold text-sm px-7 py-3.5 rounded-full hover:bg-amber-400/10 hover:border-amber-300 transition-colors duration-300"
          >
            Dúvidas sobre seus dados? Fale conosco
          </a>
        </div>
      </main>

      <Footer />
    </div>
  );
}
